module.exports = __webpack_public_path__ + "img/icon_error02.1009df0d.svg";